import createReducer from '../utils/createReducer';
import actions from '../actions/softwareDetails';
import {DEEP_LINK_PARAM_TYPE, getComponentState, getDeepLinkParams} from '../utils/localStorageDataHandler';
import {checkSoftwareDetailsBtnStatus} from '../utils/validate';

const initialState = {};

const actionHandlers = {
    [actions.SET_SOFTWARE_NAME](state, {payload}) {
        return {
            ...state,
            softwareName: payload.fieldVal,
            softwareNameError: ''
        };
    },

    [actions.SET_SYSTEM_ID](state, {payload}) {
        return {
            ...state,
            systemId: payload.fieldVal,
            isEditing: false,
            displaySuggestions: false
        };
    },

    [actions.SET_SOFTWARE_ID](state, {payload}) {
        return {
            ...state,
            softwareId: payload.fieldVal,
            softwareIdError: ''
        };
    },

    [actions.GET_SOFTWARE_SUGGESTIONS_SUCCESS](state, {payload}) {
        let result;
        if (state.isEditing) {
            if (payload.softwareList.length !== 0) {
                result = {
                    displaySuggestions: true,
                    softwareList: payload.softwareList,
                    serviceError: false
                };
            } else {
                result = {
                    displaySuggestions: false,
                    displaySoftwareIdHelpPanel: false,
                    serviceError: 'ipmob.software_details.software.not.found'
                };
            }
        }
        return {
            ...state,
            ...result
        };
    },

    [actions.GET_ONBOARD_ADVERTISER_DETAILS_BY_EMAIL_SUCCESS](state, {payload}) {
        let result;

        if (payload.onboardAdvertiserDetails.errorCode) {
            // Indicates HAXML Flow
            if (payload.onboardAdvertiserDetails.errorCode === 'NON_GQL_ONBOARD_ADVERTISER') {
                const pmscParams = getDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams);
                if (pmscParams) {
                    result = {
                        softwareId: pmscParams.advertiserAssignedId,
                        displaySuggestions: false,
                        displaySoftwareIdHelpPanel: false,
                        softwareIdReadOnly: true,
                        enableSoftwareIdField: true,
                        enableContinueButton: true,
                        serviceError: false
                    };
                } else {
                    result = {
                        displaySuggestions: false,
                        displaySoftwareIdHelpPanel: false,
                        softwareIdReadOnly: false,
                        enableSoftwareIdField: true,
                        serviceError: false
                    };
                }
            // Indicates GQL Flow and partner has not submitted onboarding details via mutation
            } else if (payload.onboardAdvertiserDetails.errorCode === 'GQL_ONBOARD_ADVERTISER_DETAILS_NOT_FOUND' ) {
                result = {
                    displaySuggestions: false,
                    displaySoftwareIdHelpPanel: false,
                    enableSoftwareIdField: false,
                    enableContinueButton: false,
                    serviceError: 'ipmob.software_details.software.gql.error'
                };
            }
        } else {
            // Indicates GQL Flow and partner has submitted onboarding details via mutation
            result = {
                displaySuggestions: false,
                onboardAdvertiserDetails: {...payload.onboardAdvertiserDetails},
                softwareId: payload.onboardAdvertiserDetails.externalId,
                softwareIdReadOnly: true,
                enableSoftwareIdField: true,
                enableContinueButton: true,
                softwareIdError: '',
                serviceError: false
            };
        }
        return {
            ...state,
            ...result
        };
    },

    [actions.DISMISS_SUGGESTION_DROPDOWN](state, {}) {
        return {
            ...state,
            displaySuggestions: false,
            softwareList: []
        };
    },

    [actions.TOGGLE_FIELD_VIEW](state, {payload}) {
        let fieldState;
        if (payload.fieldName === 'softwareName' || !state.softwareName || !state.systemId) {
            fieldState = {
                enableSoftwareIdField: false,
                softwareId: '',
                systemId: '',
                displaySuggestions: false,
                softwareList: []
            };
        } else if (!state.softwareId) {
            fieldState = {
                softwareIdError: 'ipmob.input.field.required'
            };
        } else if (state.softwareId.includes('/') || state.softwareId.includes(' ')) {
            fieldState = {
                softwareIdError: 'ipmob.input.invalid.softwareId'
            };
        }
        return {
            ...state,
            ...fieldState
        };
    },

    [actions.ENABLE_SOFTWARE_ID_FIELD](state, {payload}) {
        return {
            ...state,
            enableSoftwareIdField: payload.flag
        };
    },

    [actions.TOGGLE_SW_DETAILS_CONTINUE_BUTTON](state, {}) {
        const enableContinueButton = checkSoftwareDetailsBtnStatus(state);
        return {
            ...state,
            enableContinueButton
        };
    },

    [actions.SOFTWARE_DETAILS_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey,
            displaySoftwareIdHelpPanel: false
        };
    },

    [actions.DISMISS_ALERT_BOX](state, {}) {
        return {
            ...state,
            serviceError: ''
        };
    },

    [actions.SOFTWARE_NAME_ERROR](state, {payload}) {
        return {
            ...state,
            softwareNameError: payload.errorKey
        };
    },

    [actions.SHOW_SOFTWARE_ID_HELP_PANEL](state, {payload}) {
        return {
            ...state,
            displaySoftwareIdHelpPanel: payload.flag
        };
    },

    [actions.SET_EDIT_STATUS](state, {payload}) {
        return {
            ...state,
            isEditing: payload.flag
        };
    },

    [actions.PRE_POPULATE_LOCAL_STATE_SOFTWARE](state, {payload}) {
        const stateData = getComponentState(payload.publicUuid, 'softwareDetails');

        if (stateData && stateData.state) {
            state = stateData.state;
        }

        return {
            ...state,
            enableContinueButton: false
        };
    },

    [actions.SET_SOFTWARE_ID_READ_ONLY](state, {payload}) {
        return {
            ...state,
            softwareIdReadOnly: payload.flag
        };
    }

};

export default createReducer(actionHandlers, initialState);
